<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col>
                    <div>
                        <p class="font-weight-bold">F. FINANCIAL GOOD STANDING </p>
                    </div>
                    <div>
                        <p>
                            Financial good standing and a university record clear of holds are required for students to receive services. Upon course registration, students are required to sign a <strong>Financial Responsibility Agreement </strong>that outlines all financial procedures, obligations, rights, and responsibilities that are summarized below:
                        </p>
                        <p>
                            Services, including but not limited to access to courses, transcript issuance, diploma release, class registration (add, drop, withdrawal, etc.), and/or housing, will be immediately suspended for students with a financial balance due or a hold of any kind on their record. Course grades for those students who have not completed their financial requirements until the end of the final exam week will not be entered. This means the credits for these courses will not be earned until the payments are made. If the student's account remains delinquent, BAU reserves the right to terminate enrollment. Additionally, they will not be cleared for graduation, nor will they receive their official transcripts or diplomas.
                            Failure to meet financial obligations to BAU will result in other collection procedures, which include account referral to credit reporting bureaus, private collection agencies, and DC Office of Tax and Revenue, and Office of Attorney General. Past-due accounts are subject to garnishments, liens and judgments, and the withholding of money from tax refunds. In addition to late fees and interest, delinquent accounts will be assessed additional collection costs up to thirty percent of the past due balance, reasonable attorney fees, and other administrative costs. Once an account is referred to a collection agency, payment must be made to the agency, not BAU.
                        </p>
                    </div>
                    <div>
                        <p>
                            <strong>Late Fee : </strong>
                            <span>Failure to make any payment on or before the due date results in a $25 late fee per credit per installment. The late fee will apply only to the tuition. Other fees (for example, activity fee, technology fee, etc.) will be deducted before applying payment for tuition.</span>
                        </p>
                        <p>
                            <strong>Return Check Fee : </strong> A $35 fee will be charged for each unpaid check returned by the bank. Moreover, BAU will recalculate the late fee until the balance is cleared.
                        </p>
                        <p>
                            <strong>Exceptional Cases : </strong>In the documented event of prolonged illness, accident, or death in the immediate family (parents, siblings, children, or spouse) or other exceptional circumstances that make it impractical to complete the program, BAU will work toward a settlement that is reasonable and fair to both parties.
                        </p>
                    </div>


                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row  justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider
                                name="status"
                                rules="required"
                                v-slot="{ valid, errors }"
                            >
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-1"
                                        v-model="form.status"
                                        name="checkbox-1"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="text-sm text-md-md ml-4"
                                    >
                                    </b-form-checkbox
                                    >

                                    <div>
                                        I confirm that the information given in this section is true, complete, and accurate section F.
                                    </div>
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button
                                type="submit"
                                @click="next"
                                variant="primary"
                                class="w-100 w-md-auto"
                            >
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
    data() {
        return {
            form: {},
        }
    },
    computed: {
        ...mapGetters({
            formData: "enrollmentAgreementForm/formData"
        })
    },
    created() {
        window.scrollTo(0,0)
    },

    methods: {
        async next(){
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid){
                this.$emit('next',1)
            }

        },
        back(){
            this.$emit('back', -1);
        }
    }
}
</script>
